<template>
  <ThemeDefaultContainerSection
    :title="modelValue.title"
    title-underline
    :description="modelValue.description"
    class="tw-bg-light-gray-1"
  >
    <div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-5 lg:tw-gap-6 tw-mt-6">
      <ThemeDefaultCardOverviewProduct
        v-for="content in modelValue.content"
        :key="`overview-product-${content._id}`"
        :image="content.image?.small || ''"
        :title="content.title"
        :description="content.description"
        class="tw-w-full md:tw-w-[calc(50%-0.75rem)] lg:tw-w-[calc(33.333%-1rem)]"
      />
    </div>
  </ThemeDefaultContainerSection>
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: Object as PropType<HomeSection<OverviewProduct[]>>,
    required: true,
  },
})
</script>
